import { useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ChangePasswordModal from "./ChangePasswordModal";

export default function OperatorLayout() {
  const { admin, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [changingPassword, setChangingPassword] = useState(false);

  if (loading) return <div style={{ padding: 40 }}>Loading…</div>;
  if (!admin) return <Navigate to="/operator/login" replace />;

  return (
    <div className="operator-shell">
      <nav className="operator-sidebar">
        <div className="brand">AFA Live Interpretation</div>
        <NavLink to="/operator/conferences" className={({ isActive }) => (isActive ? "active" : "")}>
          Conferences
        </NavLink>
        <NavLink to="/operator/speakers" className={({ isActive }) => (isActive ? "active" : "")}>
          Speakers
        </NavLink>
        <NavLink to="/operator/dictionaries" className={({ isActive }) => (isActive ? "active" : "")}>
          Dictionaries
        </NavLink>
        {admin.role === "SUPER_ADMIN" && (
          <NavLink to="/operator/operators" className={({ isActive }) => (isActive ? "active" : "")}>
            Operators
          </NavLink>
        )}
        <div className="spacer" />
        <div style={{ padding: "0 20px 8px", fontSize: 13, color: "rgba(255,255,255,0.7)" }}>
          {admin.fullName || admin.username} · {admin.role}
        </div>
        <button className="logout" onClick={() => setChangingPassword(true)}>
          Change my password
        </button>
        <button
          className="logout"
          onClick={async () => {
            await logout();
            navigate("/operator/login");
          }}
        >
          Sign out
        </button>
      </nav>
      <main className="operator-main">
        <Outlet />
      </main>
      {changingPassword && <ChangePasswordModal onClose={() => setChangingPassword(false)} />}
    </div>
  );
}
